import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { Text } from '@upright/ui/common/generic/components/typography';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';

export function WarningAlert({ children }: PropsWithChildren) {
  return (
    <Root>
      <Text color="yellow-700">{children}</Text>
    </Root>
  );
}

const Root = styled.div`
  padding: 1em 1em 1em 1.5em;
  border-radius: 4px;
  border: 1px solid ${BouColor.TOOL_WARNING_YELLOW_BORDER};
  border-left: 4px solid ${BouColor.TOOL_WARNING_YELLOW};
  background-color: ${BouColor.TOOL_WARNING_YELLOW_LIGHT};
  display: flex;
  align-items: center;
`;
